import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { stats } from '../mock/mock';

const Stats = () => {
  const { t } = useApp();
  const data = [
    [stats.destinations, t('stats.dest')],
    [stats.passengers, t('stats.pax')],
    [stats.transfers, t('stats.transfers')],
    [stats.countries, t('stats.countries')],
  ];
  return (
    <section className="py-20 brand-gradient">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white text-center">{t('stats.title')}</h2>
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {data.map(([num, label]) => (
            <div key={label} className="text-center bg-white/5 backdrop-blur border border-white/10 rounded-2xl py-8">
              <div className="text-4xl sm:text-5xl font-extrabold" style={{ color: 'var(--brand-accent)' }}>{num}</div>
              <div className="mt-2 text-sm text-white/70 font-semibold">{label}</div>
            </div>
          ))}
        </div>
        <div id="help-cta" className="mt-16 bg-white/5 backdrop-blur border border-white/10 rounded-3xl p-8 sm:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl font-extrabold text-white">{t('cta.title')}</h3>
            <p className="mt-2 text-white/70">{t('cta.subtitle')}</p>
          </div>
          <a href="#help" className="accent-btn rounded-full px-7 py-3.5 font-bold flex items-center gap-2 whitespace-nowrap">
            {t('cta.btn')} <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Stats;
